import { render, staticRenderFns } from "./AppTabSubscriptionPlan.vue?vue&type=template&id=56b26624&scoped=true"
import script from "./AppTabSubscriptionPlan.vue?vue&type=script&lang=js"
export * from "./AppTabSubscriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./AppTabSubscriptionPlan.vue?vue&type=style&index=0&id=56b26624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b26624",
  null
  
)

export default component.exports